<template>
  <div id="home">
    <div id="page" class="container">
      <div class="hello">
        <h1>Commandes en attente de BAT</h1>
        <div class="row">
          <div class="col-lg-4 col-12">
            <div class="card">
              <div class="card-body row">
                <div class="col-3 text-center">
                  <i class="fas fa-cart-arrow-down colorpurple fa-lg"></i>
                </div>
                <div class="col-9">
                  <h4>Commandes</h4>
                  {{orders.length}} commandes en attente de BAT
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="card mb-4" id="bloctaborder">
        <div class="card-body">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="orders"
            item-key="id"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :search="search"
            :footer-props="footerProps"
          >
          <template v-slot:top>
           <v-text-field
             v-model="search"
             label="Recherche "
           ></v-text-field>
         </template>
          <template v-slot:item.ref="{ item }">
            <a :href="'/order/'+ item.id">{{item.ref}}</a>
          </template>

          <template v-slot:item.date_commande="{ item }">{{ item.date_commande | moment }}</template>
          <template v-slot:item.date_livraison="{ item }">{{ item.date_livraison | moment }}</template>
          <template v-slot:item.date_bat="{ item }">
            <span v-if="item.array_options.options_envoibat">{{ item.array_options.options_envoibat}}</span>
            <span v-else>Non envoyé</span>
          </template>

          <template v-slot:item.ofone="{ item }" >{{item.ofdone}} / {{item.of.TAssetOFLine.length}}</template>
          <template v-slot:item.statut="{ item }">
            <span v-if="item.statut == 0" class="badge badge-dark">Brouillon</span>
            <span v-if="item.statut == 1" class="badge badge-warning">Attente de B.A.T.</span>
            <span v-if="item.statut == 2" class="badge badge-primary">En production</span>
            <span v-if="item.statut == 3" class="badge badge-success">Terminée</span>
          </template>

          <template v-slot:item.id="{ item }">
            <a :href="'/order/'+ item.id"><i class="far fa-eye"></i></a>
          </template>

        </v-data-table>
        </div>
      </div>
  </div>


    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import moment from 'moment'

export default {
  name: 'Home',
  components: {},
  data(){
    return {
      selected: [],
      orders : [],
      ofdone: 10,
      oftotal: 70,
      headers: [
        {
          text: 'N°',
          value: 'ref',
          sortable: true,
          align: 'left',
        },
        {
          text: 'Ref. Client',
          value: 'ref_client',
          sortable: true,
          align: 'left',
        },
        {
          text: 'Date commande',
          value: 'date_commande',
          sortable: true,
          align: 'left',
        },
        {
          text: 'Date livraison',
          value: 'date_livraison',
          sortable: true,
          align: 'left',
        },
        {
          text: 'Date envoi du B.A.T.',
          value: 'date_bat',
          sortable: true,
          align: 'left',
        },
        {
          text: 'Client',
          value: 'client.nom',
          sortable: true,
          align: 'left',
        },
        {
          text: 'OF',
          value: 'ofone',
          sortable: true,
          width: '10%',
          align: 'left',
        },
        {
          text: 'Statut',
          value: 'statut',
          sortable: true,
          align: 'left',
        },
        {
          text: '#',
          value: 'id',
          sortable: true,
          width: '10%',
          align: 'left',
        },
      ],
      sortBy: 'date_commande',
      sortDesc: true,
      search: '',
      footerProps: {
        'items-per-page-options': [25, 50, 100, 500],
      },
    }
  },
  mounted () {
    axios
      .get(
        "https://crm.bonbonprint.fr/api/index.php/orders/ordersListWithOfs?sortfield=t.date_creation&sortorder=ASC&limit=200&sqlfilters=(t.fk_statut:=:'1')",
        {
          headers: {
            'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9'
            //the token is a variable which holds the token
          }
        }
      )
      .then(response => {
        console.log(response);
        this.orders = response.data.olist
        this.orders.forEach((o) => {
            o.ofdone = o.of.TAssetOFLine.filter((obj) => obj.done == "true").length;
        });
      })
  },
  filters: {
    moment: function (date) {
      return (date) ? moment(date*1000).format('DD/MM/YYYY') : "N.C.";
    }
  }
}
</script>
